define('waajax', ['jquery'], function ($) {

  var waajax = {
    ajax: function ajax(url, data, renderPartial, callback) {
      $.get(url, data, function (resp) {
        var data = resp.replace('<body', '<body><div id="body"').replace('</body>', '</div></body>');
        var body = $(data).filter('#body');
        var cbData = !!renderPartial && renderPartial !== '' ? body.find(renderPartial) : body;
        if (!!callback && typeof callback == "function") callback(cbData);
      });
    },
    ajaxPost: function ajaxPost(url, data, renderPartial, callback) {
      $.post(url, data, function (resp) {
        var data = resp.replace('<body', '<body><div id="body"').replace('</body>', '</div></body>');
        var body = $(data).filter('#body');
        var cbData = !!renderPartial && renderPartial !== '' ? body.find(renderPartial) : body;
        if (!!callback && typeof callback == "function") callback(cbData);
      });
    }
  };

  window.waajax = waajax;

  return waajax;

  /*
    Arguments :
    url : string | url,
    data : data object for ajax request
    renderPartial: string | class or id
    callback: function
   */
});

